import * as actionTypes from '../types/user';

export function userInfo(payload) {
  return {
    type: actionTypes.USER_INFO,
    payload
  };
}

export function userLogoutRequest(payload) {
  return {
    type: actionTypes.USER_LOGOUT_REQUEST,
    payload
  };
}

export function userLogoutSuccess(payload) {
  return {
    type: actionTypes.USER_LOGOUT_SUCCESS,
    payload
  };
}

export function userLogoutFail(payload) {
  return {
    type: actionTypes.USER_LOGOUT_FAIL,
    payload
  };
}

export function userGetInfo(payload) {
  return {
    type: actionTypes.USER_GET_INFO,
    payload
  };
}

export function userGetInfoSuccess(payload) {
  return {
    type: actionTypes.USER_GET_INFO_SUCCESS,
    payload
  };
}

export function userGetInfoFail(payload) {
  return {
    type: actionTypes.USER_GET_INFO_FAIL,
    payload
  };
}

export function userGetInfoClear(payload) {
  return {
    type: actionTypes.USER_GET_INFO_CLEAR,
    payload
  };
}

export function userCorporate(payload) {
  return {
    type: actionTypes.USER_CORPORATE,
    payload
  };
}

export function userCorporateSuccess(payload) {
  return {
    type: actionTypes.USER_CORPORATE_SUCCESS,
    payload
  };
}

export function userCorporateFail(payload) {
  return {
    type: actionTypes.USER_CORPORATE_FAIL,
    payload
  };
}

export function userSetTheme(payload) {
  return {
    type: actionTypes.USER_SET_THEME,
    payload
  };
}

export function userGetPermissions(payload) {
  return {
    type: actionTypes.USER_GET_PERMISSIONS_REQUEST,
    payload
  };
}

export function userGetPermissionsSuccess(payload) {
  return {
    type: actionTypes.USER_GET_PERMISSIONS_SUCCESS,
    payload
  };
}

export function userGetPermissionsFail(payload) {
  return {
    type: actionTypes.USER_GET_PERMISSIONS_FAIL,
    payload
  };
}

export function userSetMessageIconCount(payload) {
  return {
    type: actionTypes.USER_SET_MESSAGE_ICON_COUNT,
    payload
  };
}

export function userMessageInfoVisibleOpen(payload) {
  return {
    type: actionTypes.USER_MESSAGE_INFO_VISIBLE_OPEN,
    payload
  };
}

export function userMessageInfoVisibleClose(payload) {
  return {
    type: actionTypes.USER_MESSAGE_INFO_VISIBLE_CLOSE,
    payload
  };
}

export function userConsentNeed(payload) {
  return {
    type: actionTypes.USER_CONSENT_NEED_REQUEST,
    payload
  };
}

export function userConsentNeedSuccess(payload) {
  return {
    type: actionTypes.USER_CONSENT_NEED_SUCCESS,
    payload
  };
}

export function userConsentNeedFail(payload) {
  return {
    type: actionTypes.USER_CONSENT_NEED_FAIL,
    payload
  };
}

export function userConsentSave(payload) {
  return {
    type: actionTypes.USER_CONSENT_SAVE_REQUEST,
    payload
  };
}

export function userConsentSaveSuccess(payload) {
  return {
    type: actionTypes.USER_CONSENT_SAVE_SUCCESS,
    payload
  };
}

export function userConsentSaveFail(payload) {
  return {
    type: actionTypes.USER_CONSENT_SAVE_FAIL,
    payload
  };
}
